import React from 'react';

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleAboutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.REACT_APP_NAVIGATE('/about');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleWizeAIClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // First scroll to top
    window.scrollTo(0, 0);
    // Then navigate
    window.REACT_APP_NAVIGATE('/wizeai');
    // Ensure scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <a href="/" onClick={handleLogoClick} className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-400 to-cyan-500 rounded-lg relative">
                <i className="ri-shield-check-line text-xl text-gray-900"></i>
                <div className="absolute inset-0 bg-teal-400/20 rounded-lg blur-sm"></div>
              </div>
              <span className="text-2xl font-bold text-white" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                Protect<span className="text-teal-400">Wize</span>
              </span>
            </a>
            <p className="text-gray-400 mb-6 max-w-sm">
              Transform your data into actionable insights with our powerful analytics platform.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-teal-500 hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-teal-500 hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-teal-500 hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-teal-500 hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('integrations')} className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Integrations
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <a 
                  href="/wizeai"
                  onClick={handleWizeAIClick}
                  className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  WizeAI
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/about"
                  onClick={handleAboutClick}
                  className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="/training"
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/training');
                  }}
                  className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Training
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Careers
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Press Kit
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Partners
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Community
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Webinars
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Status
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/privacy-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/privacy-policy');
                  }}
                  className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Cookie Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  GDPR
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Compliance
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors cursor-pointer">
                  Licenses
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2024 ProtectWize. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-teal-400 transition-colors text-sm cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}